import BaseModelAPI from '../BaseModelAPI';

export default class DoProgressStatusList extends BaseModelAPI {

	static entity = 'doprogressstatuslist'
	static entityName = 'doprogressstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
